/**
 * <s-sticky-header> — Wraps the storefront <header> and reflects whether the page has
 * scrolled past the top, so a transparent homepage header can switch to a solid one.
 *
 * Attributes (on <s-sticky-header>):
 *   data-scrolled — Present once the window has scrolled more than `threshold` pixels.
 *   threshold     — Scroll distance in px before the header turns solid (default 8).
 */
class SStickyHeader extends HTMLElement {
  #onScroll = () => {
    const threshold = Number(this.getAttribute('threshold') || 8);
    this.toggleAttribute('data-scrolled', window.scrollY > threshold);
  };

  connectedCallback() {
    this.#onScroll();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }
}

if (!customElements.get('s-sticky-header')) {
  customElements.define('s-sticky-header', SStickyHeader);
}
